/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, {
  useMemo,
  useState, useEffect, useRef, useCallback,
} from 'react';
import IcomoonReact from 'icomoon-react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useTheme } from 'emotion-theming';
import { v4 as uuidv4 } from 'uuid';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import StaticAddColumnDropdownComponent from './StaticAddColumnDropdownComponent';
import SwapPropDropdown from './SwapPropDropdown';
import Text from '../../../../shared/components/Text/Text';
import {
 updateProgrammedCalendarItem,
 updateReduxCalendarItem,
 updateReduxProgramItem,
 swapProgrammedItemOnChildCalendar,
 setCombineWithInfo,
 updateSavedWorkoutItem,
} from '../../ducks/calendarActions';
import capitalizeWords from '../../../../shared/utils/capitalizeWords';
import useSessionState from './hooks/useSessionState';
import { getDebouncedHandlerForTable, flushDebounceForTable } from './hooks/debounceHandler';
import { useFlushDebounceOnMouseMove } from './hooks/useFlushDebounceOnMouseMove';
import { showErrorToast } from '../../../../shared/utils/toastManager';
import { normalizeRepToken } from '../../../../shared/utils/normalizeRepToken';
import wipeRepKeywordOnMutation from '../../../../shared/utils/wipeRepKeywordOnMutation';

const RANGE_FIELDS = new Set(['load']);
const INTEGER_FIELDS = new Set(['%pr']);

const Wrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const WrapperRow = styled('div')`
  display: flex;
  width: 100%;
`;

const StaticDropdownWrapper = styled('div')`
  display: flex;
  margin-left: 16px;
  align-items: self-start;
  margin-top: 17px;
  flex-direction: column;
`;

const RemoveWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-bottom: 12px;
  margin-top: 12px;
  gap: 22px;
`;

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: scroll;
`;

const PrimaryRow = styled('div')`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const ValueRow = styled('div')`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

const PrimaryRowValue = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  margin-bottom: 3px;
`;

const RowValue = styled('input')`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  height: 32px;
  background: ${(props) => props.background};
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  text-align: center;
  border-radius: 4px;
  color: ${(props) => (props.textColor ? props.textColor : props.theme.colors.text)};

  ::placeholder {
    color: ${(props) => (props.textColor ? props.textColor : props.theme.colors.text)};
  }
`;

const SetRowValue = styled('input')`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  height: 32px;
  background: ${({ theme }) => theme.colors.surfaceSecondary};
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  text-align: center;
  color: ${({ theme }) => theme.colors.textTertiary};
  border-radius: 4px;
`;

const AddSetButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const AddColumnButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const RemoveButtonContainer = styled('div')`
  display: flex;
  min-height: 34px;
`;

const AddSetIcon = styled('div')`
  padding: 4px;
  background: ${({ theme }) => theme.colors.text};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const AddColumnIcon = styled('div')`
  padding: 4px;
  background: ${({ theme }) => theme.colors.text};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RemoveIcon = styled('div')`
  padding: 4px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
  cursor: pointer;
`;

const RowsContainer = styled('div')`
  height: 55px;
  display: flex;
  width: 100%;
  gap: 16px;
`;

const AddSetNumber = styled('input')`
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-top: none;
  border-left: none;
  border-right: none;
  width: 30px;
  text-align: center;
  height: 16px;
`;

const RowValueContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 160px;
`;

const SetRowValueContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 50px;
  max-width: 50px;
`;

const AddSetText = styled('div')`
  font-weight: 400;
  font-size: 16px;
  font-family: 'Nunito Sans';
  margin-left: 5px;
`;

const UpdateInstanceSelectContainer = styled('div')`

  min-width: 215px;

  .react-select__control {
    border: none;
    border-radius: 4px;
    min-height: 32px;
    box-shadow: none;
    background: transparent;
    cursor: pointer;
    gap: 4px;

    &:hover {
      background: transparent;
    }

    &--is-focused {
      background: transparent;
      box-shadow: none;
    }
  }

  .react-select__value-container {
    padding: 0;
    flex-shrink: 1;
  }

  .react-select__indicators {
    gap: 0;
  }

  .react-select__single-value {
    color: #6B9FD9;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: 400;
    margin: 0;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__dropdown-indicator {
    padding: 0;
    margin-left: -4px;
    color: #6B9FD9;

    &:hover {
      color: #6B9FD9;
    }

    svg {
      width: 12px;
      height: 12px;
    }
  }

  .react-select__menu {
    border: none;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    overflow: hidden;
    margin-top: 8px;
    right: 0;
  }

  .react-select__menu-list {
    padding: 0;
  }

  .react-select__option {
    font-family: 'Nunito Sans';
    font-size: 14px;
    color: ${({ theme }) => theme.colors.text};
    font-weight: 400;
    cursor: pointer;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    &--is-selected {
      background-color: transparent;
      color: ${({ theme }) => theme.colors.textTertiary};
      font-weight: 400;
    }

    &--is-focused {
      background-color: ${({ theme }) => theme.colors.surfaceSecondary};

      &:not(.react-select__option--is-selected)::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background-color: #FF8A65;
      }
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.surfaceSecondary};
    }

    &:active {
      background-color: ${({ theme }) => theme.colors.surfaceSecondary};
    }
  }
`;

const AddSetLeftContainer = styled('div')`
  display: flex;
  align-items: center;
`;

const NameAndDropdown = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3px;
`;

// Custom dropdown indicator for React-Select
const CustomDropdownIndicator = ({ innerProps, selectProps }) => (
  <div
    {...innerProps}
    style={{
      padding: 0,
      marginLeft: -4,
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <IcomoonReact
      iconSet={iconSet}
      size={12}
      icon='down-arrow'
      color='#6B9FD9'
      style={{
        transition: 'transform 0.2s ease',
        transform: selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      }}
    />
  </div>
);

CustomDropdownIndicator.propTypes = {
  innerProps: PropTypes.instanceOf(Object).isRequired,
  selectProps: PropTypes.instanceOf(Object).isRequired,
};

// Update instance options - defined outside component to prevent re-creation
const updateInstanceOptions = [
  { value: 'single', label: 'Update only this instance', dropdownLabel: 'Update only this instance (Default)' },
  { value: 'all', label: 'Update all future instances', dropdownLabel: 'Update all future instances' },
];

// Custom styles for React-Select to control spacing
/* Factory, not a constant: these styles read theme colors, and a module
 * constant has no theme in scope. */
const makeUpdateInstanceSelectStyles = (colors) => ({
  valueContainer: (provided) => ({
    ...provided,
    padding: '0',
    paddingRight: '4px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    padding: '0',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '0',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'transparent' : (state.isFocused ? colors.surfaceSecondary : 'transparent'),
    color: state.isSelected ? colors.textTertiary : colors.text,
    whiteSpace: 'nowrap',
    '&:active': {
      backgroundColor: colors.surfaceSecondary,
    },
  }),
  menu: (provided) => ({
  ...provided,
  backgroundColor: colors.surfaceElevated,
  color: colors.text,
    width: '300px',
    marginLeft: '-100px',
  }),
  menuList: (provided) => ({
    ...provided,
    width: '300px',
    boxShadow: '0 4px 8px 0 rgba(48, 49, 51, 0.10), 0 0 1px 0 rgba(48, 49, 51, 0.05)',
    borderColor: '#444444',
  }),
});

const PrimaryValueContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  width: 100%;
  min-width: 160px;
`;

const SetPrimaryValueContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 16px;
  min-width: 50px;
  max-width: 50px;
`;

const ExerciseTable = ({
  content,
  index,
  coachCompletion,
  completionOnly,
  isLeftAndRight,
  trackRepCount,
  trackVolumeLoad,
  forcePrUpdate,
  disablePrUpdate,
  swapDropdownSelectedExercise,
  nonSwappedItemFromParentCalendar,
  isRecurring,
  measure,
  date,
  dayNumber,
}) => {
  const dispatch = useDispatch();
  const { colors } = useTheme();
  const updateInstanceSelectStyles = useMemo(
    () => makeUpdateInstanceSelectStyles(colors),
    [colors],
  );

  // Generate unique IDs for tooltips
  const repsTooltipId = `reps-tooltip-${content.assignedId}`;
  const timeTooltipId = `time-tooltip-${content.assignedId}`;
  const peakPowerTooltipId = `peak-power-tooltip-${content.assignedId}`;
  const velocityTooltipId = `velocity-tooltip-${content.assignedId}`;
  const restTooltipId = `rest-tooltip-${content.assignedId}`;

  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedProgramDayNumber = useSelector(
      (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const endpointFormattedDate = moment(date).format('YYYY-MM-DD');
  const combineWithInfo = useSelector((state) => state.calendar.data.combineWithInfo);
  const focusTarget = useSelector((state) => state.calendar.data.focusTarget);
  const [numberForAdd, setNumberForAdd] = useState(1);
  const [selectedUpdateOption, setSelectedUpdateOption] = useState(updateInstanceOptions[0]);
  const [primaryRows, setPrimaryRows] = useState([
    { name: 'set' },
    { name: content?.repType === 'time' ? 'time' : 'reps' },
    { name: 'load' },
    { name: 'rest', label: 'Rest (s)' },
    { name: 'tempo' },
    { name: 'velocity' },
    { name: 'peak power', label: 'Peak Power (w)' },
    { name: '%pr' },
  ]);

  const [tempo, setTempo] = useState(null);
  const [rest, setRest] = useState(null);
  const [velocity, setVelocity] = useState(content?.trackBarSpeed || false);
  const [peakPowerEnum, setPeakPowerEnum] = useState(content?.trackPeakPower);
  const [isBodyweight, setIsBodyweight] = useState(content?.repsOnly);
  const [isTime, setIsTime] = useState(content?.repType === 'time');

  const [firstPrimaryRowSwitchLoad, setFirstPrimaryRowSwitchLoad] = useState(true);
  const [firstContentLoad, setFirstContentLoad] = useState(true);
  const [firstLoadDropdownOptions, setFirstLoadDropdownOptions] = useState(true);

  /** we need to use session storage for primary row switch values so that if the user adds a field
   * it will not get wiped out between debounces if they haven't entered a value yet, changes to individual table properties
   *  will persist the session
   */
  const [primaryRowSwitch, setPrimaryRowSwitchState] = useSessionState(
    'primaryRowSwitch',
    content?.assignedId,
    {
      set: true,
      reps: content?.repType !== 'time',
      time: content?.repType === 'time',
      load: !content?.repsOnly && (content?.sets || []).some((s) => s.prescribedValue),
      bodyweight: !!content?.repsOnly,
      rest: !!content?.restTime,
      tempo: !!content?.tempo,
      velocity: !!content?.trackBarSpeed,
      'peak power': !!content?.trackPeakPower,
      '%pr': (content?.sets || []).some((s) => s.percent),
    },
  );

  const keySwapDictionary = {
    load: 'prescribedValue',
    '%pr': 'percent',
    set: 'setNumber',
    reps: 'reps',
    time: 'reps',
  };

  const [rows, setRows] = useState(content?.sets || []);

  // Ref for the table container, used to scope keyboard shortcuts
  const tableContainerRef = useRef(null);

  const typeFormatter = (typeDescription) => {
    if (typeDescription === 'lift') {
      return 'lift';
    }
    if (typeDescription === 'cardio') {
      return 'saq+c';
    }
    if (typeDescription === 'circuit') {
      return 'circuit';
    }
    return '';
  };

  const formatDate = () => `${moment(date).format('YYYY-MM-DD')}`;

  const hasMounted = useRef(false);

   useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true; /** skip first run because cell measurer wrapper will get that and we don't want to run it twice */
      return;
    }
    if (measure) {
      measure();
    }
  }, [rows]);

  /** debounced function will maintain values at the time of creation
     * on mount unless passed updated values, we can't to make sure we are
     * always using the most updated selected date and current user
     */
  const currentUserRef = useRef(currentUser);
  const selectedDateRef = useRef(date);
  const dayNumberRef = useRef(dayNumber);
  useEffect(() => {
    currentUserRef.current = currentUser;
    selectedDateRef.current = date;
    dayNumberRef.current = dayNumber;
  }, [currentUser, date, dayNumber]);

  useFlushDebounceOnMouseMove(content.assignedId, nonSwappedItemFromParentCalendar);

  const debouncedHandleUpdateLiftItem = getDebouncedHandlerForTable(content.assignedId, (
    updatedRows,
    dbrest,
    dbtempo,
    dbPeakPower,
    dbVelocity,
    dbCompletionOnly,
    dbCoachCompletion,
    dbIsLeftAndRight,
    dbTrackRepCount,
    dbTrackVolumeLoad,
    dbIsBodyweight,
    dbIsTime,
    dbForcePrUpdate,
    dbDisablePrUpdate,
    dbContent,
    dbIndex,
    dbNonSwappedItemFromParentCalendar,
    reorder = false,
    updateOption = 'single',
    dbBatchId = undefined,
  ) => {
    const updateItem = {
      assignedId: dbContent.assignedId,
      exerciseId: dbContent.exerciseId,
      order: dbIndex,
      sets: updatedRows,
      groupingLetter: dbContent.groupingLetter,
      coachCompletion: dbCoachCompletion,
      completionOnly: dbCompletionOnly,
      eachSide: dbIsLeftAndRight,
      description: dbContent?.exercise?.description || '',
      additionalInfo: dbContent?.additionalInfo,
      type: 'lift',
      trackPeakPower: dbPeakPower,
      trackRepCount: dbTrackRepCount,
      trackVolumeLoad: dbTrackVolumeLoad,
      repsOnly: dbIsBodyweight,
      repType: dbIsTime ? 'time' : 'reps',
      forceMaxUpdate: dbForcePrUpdate,
      maxTrackingDisabled: dbDisablePrUpdate,
    };
    if (programType !== 'free-form-program') {
      if (!isRecurring) {
        updateItem.date = moment(selectedDateRef.current).format('YYYY-MM-DD');
      } else {
        updateItem.isRecurring = isRecurring;
      }
    }
    if (programType === 'free-form-program') {
      updateItem.dayNumber = dayNumberRef.current;
    }
    if (dbrest) {
      updateItem.restTime = dbrest;
    }
    if (dbtempo) {
      updateItem.tempo = dbtempo;
    }
    if (dbVelocity) {
      updateItem.trackBarSpeed = dbVelocity;
    }
    if (programType === 'free-form-program') {
      dispatch(updateSavedWorkoutItem(currentUserRef.current.accountCode, updateItem, dbIndex, dayNumberRef.current, reorder));
    }
    if (programType === 'calendar') {
      if (dbNonSwappedItemFromParentCalendar) {
      dispatch(swapProgrammedItemOnChildCalendar(currentUserRef.current.accountCode, updateItem, dbIndex, formatDate(selectedDateRef.current), reorder, { batchId: dbBatchId }));
    } else {
      dispatch(updateProgrammedCalendarItem(currentUserRef.current.accountCode, updateItem, dbIndex, formatDate(selectedDateRef.current), reorder, { batchId: dbBatchId }));
    }
    }
  }, 4000);

  /** This useEffect listens for changes is the exercise chosen from the
   * table dropdown menu that can be used to change the exericse
   * it immediately updates the item in redux so we see the change in the table
   * immediately... we need to re create the object to pass to redux, then we call the debouce update the same way we do
   * for every other input change
   */

  useEffect(() => {
    if (swapDropdownSelectedExercise) {
      const updatedItem = {
        ...content,
        assignedId: content.assignedId,
        date: programType === 'free-form-program' ? '' : formatDate(date),
        exerciseId: swapDropdownSelectedExercise.exerciseId,
        /** additionalInfo: swapDropdownSelectedExercise?.additionalInfo, */
        description: swapDropdownSelectedExercise?.description,
        order: index,
        sets: rows,
        exercise: swapDropdownSelectedExercise,
        title: swapDropdownSelectedExercise?.name,
        coachCompletion,
        completionOnly,
        eachSide: isLeftAndRight,
        type: typeFormatter(swapDropdownSelectedExercise.typeDescription),
        trackPeakPower: peakPowerEnum,
        trackRepCount,
        trackVolumeLoad,
        repsOnly: isBodyweight,
        repType: isTime ? 'time' : 'reps',
        forceMaxUpdate: forcePrUpdate,
        maxTrackingDisabled: disablePrUpdate,
      };
      if (rest) {
        updatedItem.restTime = rest;
      }
      if (!rest) {
        delete updatedItem.restTime;
      }
      if (tempo) {
        updatedItem.tempo = tempo;
      }
      if (velocity) {
        updatedItem.trackBarSpeed = velocity;
      }
      if (programType === 'free-form-program') {
      dispatch(updateReduxProgramItem(updatedItem, dayNumber || selectedProgramDayNumber, index));
      } else {
      dispatch(updateReduxCalendarItem(updatedItem, endpointFormattedDate, index));
      }
      debouncedHandleUpdateLiftItem(
        rows,
        rest,
        tempo,
        peakPowerEnum,
        velocity,
        completionOnly,
        coachCompletion,
        isLeftAndRight,
        trackRepCount,
        trackVolumeLoad,
        isBodyweight,
        isTime,
        forcePrUpdate,
        disablePrUpdate,
        updatedItem,
        index,
        nonSwappedItemFromParentCalendar,
        false,
        selectedUpdateOption.value,
      );
      flushDebounceForTable(content.assignedId);
    }
  }, [swapDropdownSelectedExercise]);

  useEffect(() => {
    /** handle check for array of sources */
    const isSource = combineWithInfo?.source?.length
    ? combineWithInfo.source.some((item) => item?.assignedId.toString() === content?.assignedId.toString())
    : false;

    const sourceItem = combineWithInfo?.source?.find(
      (item) => item?.assignedId.toString() === content?.assignedId.toString(),
    );
    const isTarget = combineWithInfo?.target?.assignedId === content?.assignedId;

    const targetItem = combineWithInfo?.target;

    if (combineWithInfo && ((isSource) || (isTarget))) {
      dispatch(setCombineWithInfo(null));
      const updateItem = {
        assignedId: content.assignedId,
        exerciseId: content.exerciseId,
        order: index,
        sets: rows,
        groupingLetter: isSource
          ? sourceItem?.groupingLetter
          : isTarget
            ? targetItem?.groupingLetter
            : content?.groupingLetter,
        groupingColorCode: isSource
          ? sourceItem?.groupingColorCode
          : isTarget
            ? targetItem?.groupingColorCode
            : content?.groupingColorCode,
        coachCompletion,
        completionOnly,
        eachSide: isLeftAndRight,
        description: content?.exercise?.description || '',
        additionalInfo: content?.additionalInfo,
        type: content.type,
        trackPeakPower: peakPowerEnum,
        trackRepCount,
        trackVolumeLoad,
        repsOnly: isBodyweight,
        repType: isTime ? 'time' : 'reps',
        forceMaxUpdate: forcePrUpdate,
        maxTrackingDisabled: disablePrUpdate,
      };
      if (content.restTime) {
        updateItem.restTime = content.restTime;
      }
      if (content.tempo) {
        updateItem.tempo = content.tempo;
      }
      if (content.trackBarSpeed) {
        updateItem.trackBarSpeed = content.trackBarSpeed;
      }
      /** Only the combine target should trigger the position reorder - every
       * source row hitting its own updateCalendarItemsOrder call too would
       * fire N redundant reorder PUTs for one logical move. Each row also
       * mints its own independent batchId rather than sharing
       * combineWithInfo.batchId: the backend's dedup-by-batchId check for
       * ASSIGNMENT_UPDATE is scoped only by (batch_id, account), not by
       * assignedId, so different items sharing one batchId would silently
       * merge into a single action and lose each other's undo snapshots. */
      const reorder = isTarget;
      const combineBatchId = uuidv4();
      debouncedHandleUpdateLiftItem(
        rows,
        rest,
        tempo,
        peakPowerEnum,
        velocity,
        completionOnly,
        coachCompletion,
        isLeftAndRight,
        trackRepCount,
        trackVolumeLoad,
        isBodyweight,
        isTime,
        forcePrUpdate,
        disablePrUpdate,
        updateItem,
        index,
        nonSwappedItemFromParentCalendar,
        reorder,
        selectedUpdateOption.value,
        combineBatchId,
      );
      flushDebounceForTable(content.assignedId);
    }
  }, [combineWithInfo]);

  // This useEffect is responsible for managing focus on input fields when the focusTarget changes.
  // It checks if the current focusTarget's assignedId matches the content's assignedId.
  // If they match, it finds the first input element with a data-focus-target attribute equal to the content's assignedId.
  // Once found, it sets a timeout to focus on this input element after a short delay, ensuring the DOM is ready.
  useEffect(() => {
    if (focusTarget?.assignedId === content.assignedId) {
      const firstInput = document.querySelector(`[data-focus-target="${content.assignedId}"]`);
      if (firstInput) {
        setTimeout(() => {
          firstInput.focus();
        }, 100); // Small delay to ensure DOM is ready
      }
    }
  }, [focusTarget, content.assignedId]);

  /**
   * This is a useEffect that ensures that a. the various upper level dropdown options
   * being set to their default state doesn't trigger a put request, and b. subsequent
   * changes to the associated dropdown options DO trigger a put request
   */
  useEffect(() => {
    if (!firstLoadDropdownOptions) {
      debouncedHandleUpdateLiftItem(
        rows,
        rest,
        tempo,
        peakPowerEnum,
        velocity,
        completionOnly,
        coachCompletion,
        isLeftAndRight,
        trackRepCount,
        trackVolumeLoad,
        isBodyweight,
        isTime,
        forcePrUpdate,
        disablePrUpdate,
        content,
        index,
        nonSwappedItemFromParentCalendar,
        false,
        selectedUpdateOption.value,
      );
      if (nonSwappedItemFromParentCalendar) {
        flushDebounceForTable(content.assignedId);
      }
    } else {
      setFirstLoadDropdownOptions(false);
    }
  }, [
    coachCompletion,
    completionOnly,
    isLeftAndRight,
    trackRepCount,
    trackVolumeLoad,
    isBodyweight,
    isTime,
    peakPowerEnum,
    velocity,
    forcePrUpdate,
    disablePrUpdate,
  ]);

  // Track if all optional columns are enabled to hide the add column button
  const [showAddColumnButton, setShowAddColumnButton] = useState(true);

  // Hide add column button when all optional properties are enabled
  useEffect(() => {
    const allOptionalPropertiesEnabled = primaryRowSwitch.rest
      && primaryRowSwitch.tempo
      && primaryRowSwitch.velocity
      && primaryRowSwitch['peak power']
      && primaryRowSwitch['%pr']
      && (primaryRowSwitch.load || primaryRowSwitch.bodyweight);

    setShowAddColumnButton(!allOptionalPropertiesEnabled);
  }, [
    primaryRowSwitch.rest,
    primaryRowSwitch.tempo,
    primaryRowSwitch.velocity,
    primaryRowSwitch['peak power'],
    primaryRowSwitch['%pr'],
    primaryRowSwitch.load,
    primaryRowSwitch.bodyweight,
  ]);

  /**
 * Updates the state of the primary row switch toggle and optionally modifies the rows array
 * based on the updated state. This function ensures that deactivated rows are removed
 * and the corresponding state for `tempo`, `rest`, `peak power`, and `velocity` is updated.
 * It also triggers the debounced update function to sync changes with the backend.
 *
 * Key features:
 * - Prevents unnecessary PUT requests on the initial load by managing a
 * `firstPrimaryRowSwitchLoad` flag.
 * - Deletes inactive fields from each row in the `rows`
 * array when their corresponding switch is toggled off.
 * - Updates `tempo`, `rest`, `peak power`, and `velocity` states as needed.
 * - Invokes a debounced backend update with the updated rows and state.
 */
  const setPrimaryRowSwitch = (newState) => {
    setPrimaryRowSwitchState((prevState) => {
      const updatedState = { ...prevState, ...newState };

      if (!firstPrimaryRowSwitchLoad) {
        setFirstPrimaryRowSwitchLoad(false);

        // Check if any columns are being removed (turned from true to false)
        const columnsBeingRemoved = Object.keys(newState).some((key) => prevState[key] === true && newState[key] === false);

        const initializedRows = [...rows];
        const updatedRows = initializedRows.map((row) => {
          const cleanedRow = { ...row };
          Object.keys(newState).forEach((key) => {
            const field = keySwapDictionary[key];
            if (!field || newState[key]) return;
            // reps and time both map to the 'reps' row field. Don't delete the
            // field if a sibling key sharing it is still true in the merged
            // next state (handles partial newState callers correctly).
            const fieldStillNeeded = Object.entries(keySwapDictionary).some(
              ([otherKey, otherField]) => otherKey !== key && otherField === field && updatedState[otherKey],
            );
            if (!fieldStillNeeded) {
              delete cleanedRow[field];
            }
          });
          return cleanedRow;
        });
        setRows(updatedRows);

        let newTempoValue;
        if (!newState.tempo) {
          setTempo(null);
          newTempoValue = null;
        } else {
          newTempoValue = tempo;
        }
        let newRestValue;
        if (!newState.rest) {
          setRest(null);
          newRestValue = null;
        } else {
          newRestValue = rest;
        }
        let bodyweightSetting;
        if (!newState.bodyweight) {
          setIsBodyweight(false);
          bodyweightSetting = false;
        } else {
          setIsBodyweight(true);
          bodyweightSetting = true;
        }
        let timeSetting;
        if (!newState.time) {
          setIsTime(false);
          timeSetting = false;
        } else {
          setIsTime(true);
          timeSetting = true;
        }
        let peakPowerEnumSetting;
        if (!newState['peak power']) {
          setPeakPowerEnum(0);
          peakPowerEnumSetting = 0;
        } else {
          setPeakPowerEnum(1);
          peakPowerEnumSetting = 1;
        }

        const updatedVelocity = newState.velocity;
        setVelocity(updatedVelocity);

        // Always call API when columns are being removed, otherwise check for empty fields
        if (columnsBeingRemoved) {
          // If columns are being removed, always trigger the API call
          debouncedHandleUpdateLiftItem(
            updatedRows,
            newRestValue,
            newTempoValue,
            peakPowerEnumSetting,
            updatedVelocity,
            completionOnly,
            coachCompletion,
            isLeftAndRight,
            trackRepCount,
            trackVolumeLoad,
            bodyweightSetting,
            timeSetting,
            forcePrUpdate,
            disablePrUpdate,
            content,
            index,
            nonSwappedItemFromParentCalendar,
            false,
            selectedUpdateOption.value,
          );
        } else {
          // For adding columns, check if any fields are empty before making API call
          // Exclude 'load' field from empty validation - load can be empty
          const fieldsToCheck = Object.keys(newState).filter((key) => newState[key] && keySwapDictionary[key] && key !== 'load');
          const hasEmptyFields = fieldsToCheck.some((key) => {
            const fieldKey = keySwapDictionary[key];
            return updatedRows.some((row) => {
              const fieldValue = row[fieldKey];
              return !fieldValue || fieldValue === null || fieldValue === '';
            });
          });

          // Only call the API if no fields are empty or if no trackable fields are active
          if (!hasEmptyFields || fieldsToCheck.length === 0) {
            debouncedHandleUpdateLiftItem(
              updatedRows,
              newRestValue,
              newTempoValue,
              peakPowerEnumSetting,
              updatedVelocity,
              completionOnly,
              coachCompletion,
              isLeftAndRight,
              trackRepCount,
              trackVolumeLoad,
              bodyweightSetting,
              timeSetting,
              forcePrUpdate,
              disablePrUpdate,
              content,
              index,
              nonSwappedItemFromParentCalendar,
              false,
              selectedUpdateOption.value,
            );
          }
        }
      }

      return updatedState;
    });
    setFirstPrimaryRowSwitchLoad(false);
  };

  /**
 * Initializes the state of primary row switches and associated properties (tempo, rest, peak power)
 * based on the `content` (calendarItem) data when the component loads.
 * Specifically, it checks for `prescribedValue`,
 * `tempo`, `restTime`, and `trackPeakPower` in the `content` object and enables the corresponding
 * columns in the `primaryRowSwitch` state. Ensures this initialization logic only runs once
 * during the first load by checking the `firstContentLoad` flag.
 *
 * Dependencies:
 * - Runs whenever the `content` object changes.
 */
  useEffect(() => {
    if (content && content.sets) {
      const isTimeType = content.repType === 'time';
      const roundPercent = (set) => {
        if (set.percent === null || set.percent === undefined || set.percent === '') return set;
        const n = parseFloat(set.percent);
        if (Number.isNaN(n)) return set;
        return { ...set, percent: String(Math.round(n)) };
      };
      const initialSets = content.sets.map((set) => {
        let next = roundPercent(set);
        if (isTimeType && typeof next.reps === 'string' && next.reps.toUpperCase() === 'AMAP') {
          next = { ...next, reps: 'ALAP' };
        }
        return next;
      });
      setRows(initialSets);

      if (firstContentLoad) {
        // Derive switches entirely from data so stale session-stored flags (e.g. from a
        // previous tab session where a property was later removed via the
        // UpdateFutureOccurrences modal) don't leave empty columns visible after reload.
        const freshSwitch = {
          set: true,
          reps: !isTimeType,
          time: isTimeType,
          load: !content.repsOnly && content.sets.some((s) => s.prescribedValue),
          bodyweight: !!content.repsOnly,
          rest: !!content.restTime,
          tempo: !!content.tempo,
          velocity: !!content.trackBarSpeed,
          'peak power': !!content.trackPeakPower,
          '%pr': content.sets.some((s) => s.percent),
        };
        if (content.tempo) setTempo(content.tempo);
        if (content.restTime) setRest(content.restTime);
        if (content.trackPeakPower) setPeakPowerEnum(content.trackPeakPower);
        if (content.repsOnly) {
          setIsBodyweight(true);
          setPrimaryRows(
            (prevRows2) => prevRows2.map(
              (row) => (row.name === 'load' ? { ...row, name: 'bodyweight' } : row),
            ),
          );
        }
        if (isTimeType) {
          setIsTime(true);
          setPrimaryRows(
            (prevRows2) => prevRows2.map(
              (row) => (row.name === 'reps' ? { ...row, name: 'time' } : row),
            ),
          );
        }
        setPrimaryRowSwitch(freshSwitch);
        setPrimaryRowSwitchState(freshSwitch);
        setFirstContentLoad(false);
      } else {
        // Merge-only so in-session column adds (added but not yet typed into) survive
        // debounced save responses that arrive without that field's data.
        const newPrimaryRowSwitch = { ...primaryRowSwitch };
        content.sets.forEach((set) => {
          if (set.prescribedValue) {
            newPrimaryRowSwitch.load = true;
          }
          if (set.percent) {
            newPrimaryRowSwitch['%pr'] = true;
          }
        });
        if (content.tempo) {
          newPrimaryRowSwitch.tempo = true;
          setTempo(content.tempo);
        }
        if (content.restTime) {
          newPrimaryRowSwitch.rest = true;
          setRest(content.restTime);
        }
        if (content.trackPeakPower) {
          newPrimaryRowSwitch['peak power'] = true;
          setPeakPowerEnum(content.trackPeakPower);
        }
        if (content.repsOnly) {
          newPrimaryRowSwitch.bodyweight = true;
          setIsBodyweight(true);
          setPrimaryRows(
            (prevRows2) => prevRows2.map(
              (row) => (row.name === 'load' ? { ...row, name: 'bodyweight' } : row),
            ),
          );
        }
        if (isTimeType) {
          newPrimaryRowSwitch.time = true;
          setIsTime(true);
          setPrimaryRows(
            (prevRows2) => prevRows2.map(
              (row) => (row.name === 'reps' ? { ...row, name: 'time' } : row),
            ),
          );
        }
        setPrimaryRowSwitchState(newPrimaryRowSwitch);
      }
    }
  }, [content]);

  // Format option label with checkmark for selected option (only in dropdown menu)
  const formatUpdateOptionLabel = useCallback((option, { context }) => {
    if (context === 'menu') {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <span>{option.dropdownLabel || option.label}</span>
          {selectedUpdateOption.value === option.value && (
            <IcomoonReact iconSet={iconSet} size={12} icon='checkmark' color={colors.textSecondary} />
          )}
        </div>
      );
    }
    // For button value display, just return the text without wrapper
    return option.label;
  }, [selectedUpdateOption]);

  const updateColumnName = useCallback((oldName, newName) => {
    setPrimaryRows(
      (prevRows2) => prevRows2.map(
        (row) => (row.name === oldName ? { ...row, name: newName } : row),
      ),
    );

    setPrimaryRowSwitch((prevSwitch) => {
      const newSwitch = { ...prevSwitch };
      // Ensure load and bodyweight are mutually exclusive
      if (newName === 'load') {
        newSwitch.bodyweight = false;
      } else if (newName === 'bodyweight') {
        newSwitch.load = false;
      }
      newSwitch[oldName] = false;
      newSwitch[newName] = true;
      return newSwitch;
    });

    // Wipe out the `load` property in rows if switching from `load` to `bodyweight`
    if (oldName === 'load' && (newName === 'bodyweight')) {
      setRows((prevRows2) => prevRows2.map((row) => {
        const updatedRow = { ...row };
        delete updatedRow[keySwapDictionary.load]; // Remove the load property
        return updatedRow;
      }));
    }
  }, []);

  const addRow = () => {
    if (numberForAdd > 0) {
      const totalRowsAfterAdd = rows.length + numberForAdd;
      if (totalRowsAfterAdd < 11) {
        const lastRow = rows[rows.length - 1];
        const newRows = Array.from({ length: numberForAdd }, (_, i) => ({
          ...lastRow,
          setNumber: rows.length + i + 1,
        }));
        const updatedRows = [...rows, ...newRows];
        setRows(updatedRows);
        debouncedHandleUpdateLiftItem(
          updatedRows,
          rest,
          tempo,
          peakPowerEnum,
          velocity,
          completionOnly,
          coachCompletion,
          isLeftAndRight,
          trackRepCount,
          trackVolumeLoad,
          isBodyweight,
          isTime,
          forcePrUpdate,
          disablePrUpdate,
          content,
          index,
          nonSwappedItemFromParentCalendar,
          false,
          selectedUpdateOption.value,
        );
      } else {
        showErrorToast('The total number of sets cannot exceed 10.');
      }
    }
  };

  const removeRow = (removeIndex) => {
    const updatedRows = rows
      .filter((_, i) => i !== removeIndex) /** Remove the row at removeIndex */
      .map((row, mapIndex) => ({
        ...row,
        setNumber: mapIndex + 1, /** Update setNumber to maintain sequential order */
      }));

    setRows(updatedRows);
    debouncedHandleUpdateLiftItem(
      updatedRows,
      rest,
      tempo,
      peakPowerEnum,
      velocity,
      completionOnly,
      coachCompletion,
      isLeftAndRight,
      trackRepCount,
      trackVolumeLoad,
      isBodyweight,
      isTime,
      forcePrUpdate,
      disablePrUpdate,
      content,
      index,
      nonSwappedItemFromParentCalendar,
      false,
      selectedUpdateOption.value,
    );
  };

  const setTempoAndUpdate = (value) => {
    setTempo(value);
    debouncedHandleUpdateLiftItem(
      rows,
      rest,
      value,
      peakPowerEnum,
      velocity,
      completionOnly,
      coachCompletion,
      isLeftAndRight,
      trackRepCount,
      trackVolumeLoad,
      isBodyweight,
      isTime,
      forcePrUpdate,
      disablePrUpdate,
      content,
      index,
      nonSwappedItemFromParentCalendar,
      false,
      selectedUpdateOption.value,
    );
  };

  const setRestAndUpdate = (value) => {
    const intRest = parseInt(value, 10);
    // Prevent negative values
    if (intRest < 0) return;
    setRest(intRest);
    debouncedHandleUpdateLiftItem(
      rows,
      intRest,
      tempo,
      peakPowerEnum,
      velocity,
      completionOnly,
      coachCompletion,
      isLeftAndRight,
      trackRepCount,
      trackVolumeLoad,
      isBodyweight,
      isTime,
      forcePrUpdate,
      disablePrUpdate,
      content,
      index,
      nonSwappedItemFromParentCalendar,
      false,
      selectedUpdateOption.value,
    );
  };

  const handleInputChange = (rowIndex, field, value) => {
    // Don't convert empty string to null here - let the auto-fill logic handle it
    // if (!value) {
    //   // eslint-disable-next-line no-param-reassign
    //   value = null;
    // }

    // Prevent negative values for numeric fields
    if ((field === 'load' || field === '%pr') && parseFloat(value) < 0) {
      return;
    }

    if (INTEGER_FIELDS.has(field) && value !== '') {
      const n = parseFloat(value);
      // eslint-disable-next-line no-param-reassign
      value = Number.isFinite(n) && n >= 0 ? String(Math.round(n)) : value.replace(/\D/g, '');
    }

    // Prevent negative values for reps and time fields
    let normalizedFieldValue = value;
    if (field === 'reps' || field === 'time') {
      const keyword = field === 'time' ? 'ALAP' : 'AMAP';
      // Allow AMAP / ALAP
      if (value && value.toUpperCase() === keyword) {
        // keyword is valid, continue
      } else if (value && value.includes('-') && !value.startsWith('-')) {
        // Check for ranges (e.g., "8-12") but not negative numbers
        const parts = value.split('-');
        if (parts.length === 2) {
          const start = parseInt(parts[0], 10);
          const end = parseInt(parts[1], 10);
          if (start < 0 || end < 0) {
            return; // Prevent negative values in ranges
          }
        }
      } else if (value && value.includes('+') && !value.startsWith('-')) {
        // Check for minimum values (e.g., "8+") but not negative numbers
        const numPart = value.replace('+', '');
        if (parseInt(numPart, 10) < 0) {
          return; // Prevent negative minimum values
        }
      } else if (value && !Number.isNaN(Number(value))) {
        // Check for simple numbers (including negative ones)
        if (parseFloat(value) < 0) {
          return; // Prevent negative simple numbers
        }
      }

      // Normalize AMAP/ALAP case-drift ("Amap" -> "AMAP"). Invalid keyword variants
      // ("AMRAP") are detected at the row-level gate below to block the API call.
      if (value !== '' && value !== null && value !== undefined) {
        const tokenResult = normalizeRepToken(String(value), [keyword]);
        if (tokenResult.isValid) {
          normalizedFieldValue = tokenResult.value;
        }
      }
    }

    setRows((prevRows2) => {
      const fieldKey = keySwapDictionary[field];

      // Use normalized value (e.g., "Amap" -> "AMAP") for storage and submission
      const writeValue = (field === 'reps' || field === 'time') ? normalizedFieldValue : value;

      // Check if this is the first set and we should auto-fill
      const shouldAutoFill = rowIndex === 0;

      // Convert empty string to null for storage. For `percent` (%PR), drop the
      // key entirely on empty so the JSON sent to the server omits it per-set —
      // mirrors ExerciseTableSAQC's `prescribedValue` deletion. Without this,
      // a server-side default backfill would overwrite the cleared value on the
      // round-trip.
      const finalValue = writeValue === '' ? null : writeValue;
      const buildRow = (row) => {
        const next = { ...row, [fieldKey]: finalValue };
        if (fieldKey === 'percent' && (finalValue === null || finalValue === '')) {
          delete next.percent;
        }
        return next;
      };

      let updatedRows;
      if (shouldAutoFill) {
        // Get the current value in the first set
        const currentFirstSetValue = prevRows2[0][fieldKey];

        // Check if all other sets for this field are empty OR have the same value as the current first set
        const otherSetsAreEmptyOrMatchCurrent = prevRows2.slice(1).every((row) => {
          const fieldValue = row[fieldKey];
          return !fieldValue || fieldValue === null || fieldValue === '' || fieldValue === currentFirstSetValue;
        });

        if (otherSetsAreEmptyOrMatchCurrent) {
          // Auto-fill all sets with the same value
          updatedRows = prevRows2.map(buildRow);
        } else {
          // Only update the current row
          updatedRows = prevRows2.map((row, i) => (
            i === rowIndex ? buildRow(row) : row
          ));
        }
      } else {
        // Normal update - only change the current row
        updatedRows = prevRows2.map((row, i) => (
          i === rowIndex ? buildRow(row) : row
        ));
      }

      // Check if any reps/time field has empty values before making API call
      // Prevent API calls if any reps fields are empty (this prevents re-population)
      const repsFieldKey = keySwapDictionary.reps; // This maps to 'reps' for both 'reps' and 'time' fields
      const hasEmptyRepsFields = updatedRows.some((row) => {
        const repsValue = row[repsFieldKey];
        return !repsValue || repsValue === null || repsValue === '';
      });

      // Block API call only when the user is editing reps/time and their just-typed
      // token is invalid (e.g., "AMRAP"). Silent block — matches the existing
      // negative-number guards above; per-keystroke toasts would spam the UI.
      // Derive the keyword from `field`, not `isTime`, to stay consistent with the
      // keyword used by the normalization step earlier in this handler.
      const repsKeyword = field === 'time' ? 'ALAP' : 'AMAP';
      const editedRepsTokenIsInvalid = (field === 'reps' || field === 'time')
        && value !== '' && value !== null && value !== undefined
        && !normalizeRepToken(String(value), [repsKeyword]).isValid;

      // Check if any other field has empty values (excluding 'load' and '%pr' which can be empty per-set)
      const hasEmptyOtherFields = field !== 'load' && field !== '%pr' && field !== 'reps' && field !== 'time' && updatedRows.some((row) => {
        const fieldValue = row[fieldKey];
        return !fieldValue || fieldValue === null || fieldValue === '';
      });

      // Only call the API if no reps fields are empty and no other fields are empty
      if (!hasEmptyRepsFields && !hasEmptyOtherFields && !editedRepsTokenIsInvalid) {
        debouncedHandleUpdateLiftItem(
          updatedRows,
          rest,
          tempo,
          peakPowerEnum,
          velocity,
          completionOnly,
          coachCompletion,
          isLeftAndRight,
          trackRepCount,
          trackVolumeLoad,
          isBodyweight,
          isTime,
          forcePrUpdate,
          disablePrUpdate,
          content,
          index,
          nonSwappedItemFromParentCalendar,
          false,
          selectedUpdateOption.value,
        );
      }

      return updatedRows;
    });
  };

  // Helper function to validate key input for numbers-only fields
  // Pass allowRangeNotation=true for load (range/+ notation allowed)
  const isValidNumberKey = (key, currentValue, allowRangeNotation = false, allowDecimal = true) => {
    // Allow navigation and editing keys
    if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(key)) {
      return true;
    }

    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+Z
    if (key === 'a' || key === 'c' || key === 'v' || key === 'x' || key === 'z') {
      return true; // These will be handled by the browser with Ctrl modifier
    }

    // Allow decimal point; for range fields allow one per segment (split by '-')
    if (key === '.' && allowDecimal) {
      if (allowRangeNotation) {
        const currentSegment = currentValue.split('-').pop();
        if (!currentSegment.includes('.')) return true;
      } else if (!currentValue.includes('.')) {
        return true;
      }
    }

    // Allow digits
    if (/^\d$/.test(key)) {
      return true;
    }

    // Allow dash (range) and plus notation for range fields
    if (allowRangeNotation && (key === '-' || key === '+')) {
      return true;
    }

    return false;
  };

  // Helper function to validate key input for reps fields (allows AMAP and ranges)
  const isValidRepsKey = (key) => {
    // Allow navigation and editing keys
    if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(key)) {
      return true;
    }

    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+Z
    if (key === 'a' || key === 'c' || key === 'v' || key === 'x' || key === 'z') {
      return true; // These will be handled by the browser with Ctrl modifier
    }

    // Allow digits
    if (/^\d$/.test(key)) {
      return true;
    }

    // Allow letters for AMAP
    if (/^[a-zA-Z]$/.test(key)) {
      return true;
    }

    // Allow dash for ranges (8-12) and plus for minimums (8+)
    if (key === '-' || key === '+') {
      return true;
    }

    return false;
  };

  const columnInputResolver = (originalName, rowIndex, row) => {
    let name = originalName;
    if (name === 'time') {
      // eslint-disable-next-line no-param-reassign
      name = 'reps';
    }
    const fieldValue = row[keySwapDictionary[name]];
    if (name === 'tempo') {
      return (
        <RowValueContainer>
          <RowValue
            value={tempo}
            onChange={(e) => setTempoAndUpdate(e.target.value)}
            background={colors.surfaceSecondary}
          />
        </RowValueContainer>
      );
    }
    if (name === 'rest') {
      return (
        <RowValueContainer>
          <RowValue
            type='number'
            value={rest}
            onChange={(e) => setRestAndUpdate(e.target.value)}
            onKeyDown={(e) => {
              // Prevent commas and validate for numbers-only field
              if (e.key === ',' || (!e.ctrlKey && !isValidNumberKey(e.key, e.target.value))) {
                e.preventDefault();
              }
            }}
            background={colors.surfaceSecondary}
          />
        </RowValueContainer>
      );
    }
    if (name === 'peak power') {
      if (peakPowerEnum === 1) {
        return (
          <RowValueContainer>
            <RowValue
              disabled
              placeholder='-'
              textColor={colors.textPlaceholder}
              background={colors.surfaceSecondary}
            />
          </RowValueContainer>
        );
      }
      return (
        <RowValueContainer>
          <RowValue
            disabled
            placeholder='Left'
            textColor={colors.textPlaceholder}
            style={{ marginRight: 8 }}
            background={colors.surfaceSecondary}
          />
          <RowValue
            disabled
            placeholder='Right'
            textColor={colors.textPlaceholder}
            style={{ marginLeft: 8 }}
            background={colors.surfaceSecondary}
          />
        </RowValueContainer>
      );
    }
    return (
      <RowValueContainer>
        <RowValue
          type='text'
          aria-label={`${name} for set ${rowIndex + 1}`}
          value={name === 'bodyweight' ? '' : (fieldValue || '')} // Convert null/undefined to empty string for React input
          onChange={(e) => {
            handleInputChange(rowIndex, originalName, e.target.value);
          }}
          onKeyDown={(e) => {
            // Always prevent commas
            if (e.key === ',') {
              e.preventDefault();
              return;
            }

            // Skip validation for disabled fields
            if (name === 'velocity' || name === 'bodyweight') {
              return;
            }

            // If the user is mutating an AMAP/ALAP token they're sitting in the
            // middle of, block the keystroke and restore — except Backspace,
            // which deletes the whole token (opt-in via backspaceDeletes).
            if (name === 'reps' || name === 'time' || originalName === 'time') {
              const keyword = (name === 'time' || originalName === 'time') ? 'ALAP' : 'AMAP';
              const { value, selectionStart, selectionEnd } = e.target;
              const wipeResult = wipeRepKeywordOnMutation(e, value, selectionStart, selectionEnd, [keyword], { backspaceDeletes: true });
              if (wipeResult.wiped) {
                e.preventDefault();
                e.target.value = wipeResult.newValue;
                handleInputChange(rowIndex, originalName, wipeResult.newValue);
                const inputEl = e.target;
                requestAnimationFrame(() => {
                  inputEl.setSelectionRange(wipeResult.newCursor, wipeResult.newCursor);
                });
                return;
              }

              // Single-cell input: once the cell holds an AMAP/ALAP keyword,
              // block any printable-char keystroke that would append/prepend
              // (e.g., produce "AMAP8"). Wipe-on-edit was handled above; reaching
              // here with the cell at a keyword means the caret is at an edge.
              const cellTrimmed = (value || '').trim().toUpperCase();
              if (cellTrimmed === keyword
                  && typeof e.key === 'string'
                  && e.key.length === 1
                  && !e.ctrlKey && !e.metaKey) {
                e.preventDefault();
                return;
              }
            }

            // Handle keyword autocomplete (AMAP for reps, ALAP for time) on typing 'a' in empty field
            if ((name === 'reps' || name === 'time' || originalName === 'time') && e.key.toLowerCase() === 'a' && (!e.target.value || e.target.value === '')) {
              const keyword = (name === 'time' || originalName === 'time') ? 'ALAP' : 'AMAP';
              e.preventDefault();
              e.target.value = keyword;
              handleInputChange(rowIndex, originalName, keyword);
              return;
            }

            // Use different validation for reps vs other fields
            const isValid = (name === 'reps' || originalName === 'time')
              ? isValidRepsKey(e.key)
              : isValidNumberKey(e.key, e.target.value, RANGE_FIELDS.has(name), !INTEGER_FIELDS.has(name));

            // Allow Ctrl combinations
            if (!e.ctrlKey && !isValid) {
              e.preventDefault();
            }
          }}
          disabled={name === 'velocity' || name === 'bodyweight'}
          placeholder={name === 'velocity' || name === 'bodyweight' ? '-' : null}
          textColor={name === 'velocity' || name === 'bodyweight' ? colors.textTertiary : colors.text}
          background={colors.surfaceSecondary}
          data-focus-target={
            // Add focus target to the first editable field that's visible and in the first row
            rowIndex === 0 && (
              (name === 'reps' && primaryRowSwitch.reps)
              || (name === 'time' && primaryRowSwitch.time)
              || (name === 'load' && primaryRowSwitch.load && !primaryRowSwitch.reps && !primaryRowSwitch.time)
            )
              ? content.assignedId
              : undefined
          }
        />
      </RowValueContainer>
    );
  };

  const findCorrectUnit = (unitContent) => {
    if (unitContent?.exercise.unitAbbr) {
      if (unitContent?.exercise?.unitAbbr === 'wgt') {
        // orgWeight: 1 = kg, 0 = lbs
        const weightUnit = currentUser?.userSettings?.orgWeight === 1 ? 'kg' : 'lbs';
        return `(${weightUnit})`;
      }
      return `(${unitContent?.exercise?.unitAbbr})`;
    }
    return '';
  };

  return (
    <Wrapper
      ref={tableContainerRef}
      onBlur={nonSwappedItemFromParentCalendar
        ? () => flushDebounceForTable(content.assignedId)
        : undefined}
    >
      <WrapperRow>
        <Container>
          <PrimaryRow>
            {primaryRows.map((primaryRow) => (
              primaryRowSwitch[primaryRow.name] ? (
                primaryRow.name === 'set' ? <SetPrimaryValueContainer>{`${capitalizeWords(primaryRow.name)}s`}</SetPrimaryValueContainer> : (
                  <PrimaryValueContainer>
                    <PrimaryRowValue>
                      {primaryRow.name === 'reps' || primaryRow.name === 'time' || primaryRow.name === 'velocity' || primaryRow.name === 'peak power' ? (
                        <NameAndDropdown>
                          {(primaryRow.name === 'peak power' || primaryRow.name === 'reps' || primaryRow.name === 'time' || primaryRow.name === 'velocity') && (
                          <IcomoonReact
                            iconSet={iconSet}
                            size={14}
                            icon='info2'
                            color={colors.textSecondary}
                            style={{ cursor: 'pointer' }}
                            data-tooltip-id={
                              primaryRow.name === 'reps' ? repsTooltipId
                                : primaryRow.name === 'time' ? timeTooltipId
                                  : primaryRow.name === 'peak power' ? peakPowerTooltipId
                                    : primaryRow.name === 'velocity' ? velocityTooltipId : undefined
                            }
                          />
                          )}

                          <SwapPropDropdown
                            setPrimaryRowSwitch={setPrimaryRowSwitch}
                            primaryRowSwitch={primaryRowSwitch}
                            rowName={primaryRow.name}
                            size={12}
                            updateColumnName={updateColumnName}
                            setPeakPowerEnum={setPeakPowerEnum}
                            peakPowerEnum={peakPowerEnum}
                            name={primaryRow.name === 'load' ? capitalizeWords('Load') : primaryRow.label || capitalizeWords(primaryRow.name)}
                            unit={primaryRow.name === 'load' ? findCorrectUnit(content) : null}
                            setIsBodyweight={setIsBodyweight}
                            setIsTime={setIsTime}
                          />
                        </NameAndDropdown>
                      ) : (
                        <NameAndDropdown>
                          {(primaryRow.name === 'rest') && (
                          <IcomoonReact
                            iconSet={iconSet}
                            size={14}
                            icon='info2'
                            color={colors.textSecondary}
                            style={{ cursor: 'pointer' }}
                            data-tooltip-id={restTooltipId}
                          />
                          )}

                          <SwapPropDropdown
                            setPrimaryRowSwitch={setPrimaryRowSwitch}
                            primaryRowSwitch={primaryRowSwitch}
                            rowName={primaryRow.name}
                            size={12}
                            updateColumnName={updateColumnName}
                            setPeakPowerEnum={setPeakPowerEnum}
                            peakPowerEnum={peakPowerEnum}
                            name={primaryRow.name === 'load' ? capitalizeWords('Load') : primaryRow.label || capitalizeWords(primaryRow.name)}
                            unit={primaryRow.name === 'load' ? findCorrectUnit(content) : null}
                            setIsBodyweight={setIsBodyweight}
                            setIsTime={setIsTime}
                          />
                        </NameAndDropdown>
                      )}
                    </PrimaryRowValue>
                  </PrimaryValueContainer>
                )
              ) : null
            ))}
          </PrimaryRow>
          {rows.map((row, rowIndex) => (
            <ValueRow key={rowIndex}>
              <RowsContainer>
                {primaryRows.map((primaryRow) => (
                  primaryRowSwitch[primaryRow.name] ? (
                    primaryRow.name === 'set' ? (
                      <SetRowValueContainer>
                        <SetRowValue
                          type='number'
                          aria-label={`${primaryRow.name} for set ${rowIndex + 1}`}
                          value={rowIndex + 1}
                          disabled
                          onChange={(e) => handleInputChange(rowIndex, primaryRow.name, e.target.value)}
                        />
                      </SetRowValueContainer>
                    )
                      : columnInputResolver(primaryRow.name, rowIndex, row)
                  ) : null
                ))}
              </RowsContainer>
            </ValueRow>
          ))}
        </Container>
        <StaticDropdownWrapper>
          {showAddColumnButton && (
          <StaticAddColumnDropdownComponent
            primaryRows={primaryRows}
            setPrimaryRows={setPrimaryRows}
            primaryRowSwitch={primaryRowSwitch}
            setPrimaryRowSwitch={setPrimaryRowSwitch}
            setPrimaryRowSwitchState={setPrimaryRowSwitchState}
            size={12}
            containerRef={tableContainerRef}
            assignedId={content.assignedId}
          >
            <AddColumnButtonContainer className='add-column-button'>
              <AddColumnIcon>
                <IcomoonReact
                  iconSet={iconSet}
                  size={12}
                  icon='plus'
                  color={colors.white}
                />
              </AddColumnIcon>
            </AddColumnButtonContainer>
          </StaticAddColumnDropdownComponent>
          )}
          <RemoveWrapper>
            {rows.map((row, rowIndex) => (
                rows.length !== 1 ? (
                  <RemoveButtonContainer onClick={() => removeRow(rowIndex)} tabIndex={-1}>
                    <RemoveIcon>
                      <IcomoonReact
                        iconSet={iconSet}
                        size={12}
                        icon='remove'
                        color={colors.textSecondary}
                      />
                    </RemoveIcon>
                  </RemoveButtonContainer>
                ) : <div style={{ display: 'flex', minWidth: 20, minHeight: 34 }} />
            ))}
          </RemoveWrapper>
        </StaticDropdownWrapper>
      </WrapperRow>
      {rows?.length < 10 && (
      <AddSetButtonContainer>
        <AddSetLeftContainer>
          <AddSetIcon onClick={addRow}>
            <IcomoonReact
              iconSet={iconSet}
              size={12}
              icon='plus'
              color={colors.white}
            />
          </AddSetIcon>
          <AddSetText>
            Add
            {' '}
            <AddSetNumber
              value={numberForAdd}
              onChange={(e) => {
                const inputValue = parseInt(e.target.value, 10);
                // Prevent negative values
                if (inputValue < 0) return;
                setNumberForAdd(inputValue);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  addRow();
                }
                if (e.key === 'Tab' && !e.shiftKey) {
                  // Check if this is the last exercise in the list
                  const allExerciseElements = document.querySelectorAll('[class*="AddSetNumber"]');
                  const currentIndex = Array.from(allExerciseElements).indexOf(e.target);
                  const isLastExercise = currentIndex === allExerciseElements.length - 1;

                  if (isLastExercise) {
                    e.preventDefault();
                    // Find and focus the ExercisePicker button
                    const exercisePickerButton = document.querySelector('[class*="AddExerciseButtonContainer"]');
                    if (exercisePickerButton) {
                      exercisePickerButton.focus();
                    }
                  }
                }
              }}
              type='number'
            />
            {' '}
            {numberForAdd > 1 ? 'Sets' : 'Set'}
          </AddSetText>
        </AddSetLeftContainer>
        {/* <UpdateInstanceSelectContainer>
          <Select
            options={updateInstanceOptions}
            value={selectedUpdateOption}
            onChange={(option) => setSelectedUpdateOption(option)}
            className='react-select'
            classNamePrefix='react-select'
            isSearchable={false}
            formatOptionLabel={formatUpdateOptionLabel}
            menuPortalTarget={document.body}
            menuPosition='fixed'
            styles={updateInstanceSelectStyles}
            components={{
              DropdownIndicator: CustomDropdownIndicator,
            }}
          />
        </UpdateInstanceSelectContainer> */}
      </AddSetButtonContainer>
      )}

      {/* ReactTooltip components */}
      <ReactTooltip
        id={repsTooltipId}
        place='top'
        positionStrategy='fixed'
        appendTo={document.body}
        style={{
          zIndex: 9999,
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: colors.white,
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
          maxWidth: '250px',
          padding: '10px 16px',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <Text fontSize='13px' fontWeight={400} color={colors.white}>Accepted Inputs</Text>
          <ul style={{ paddingLeft: '20px', margin: 0 }}>
            <li>
              <Text fontSize='13px' fontWeight={400} color={colors.white}>Absolute (e.g. 5)</Text>
            </li>
            <li><Text fontSize='13px' fontWeight={400} color={colors.white}>Range (e.g. 8-12)</Text></li>
            <li><Text fontSize='13px' fontWeight={400} color={colors.white}>Minimum (e.g. 8+)</Text></li>
            <li><Text fontSize='13px' fontWeight={400} color={colors.white}>&quot;AMAP&quot; for as many as possible</Text></li>
          </ul>
        </div>
      </ReactTooltip>

      <ReactTooltip
        id={timeTooltipId}
        place='top'
        positionStrategy='fixed'
        appendTo={document.body}
        style={{
          zIndex: 9999,
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: colors.white,
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
          maxWidth: '250px',
          padding: '10px 16px',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <Text fontSize='13px' fontWeight={400} color={colors.white}>Accepted Inputs</Text>
          <ul style={{ paddingLeft: '20px', margin: 0 }}>
            <li><Text fontSize='13px' fontWeight={400} color={colors.white}>Absolute (e.g. 30)</Text></li>
            <li><Text fontSize='13px' fontWeight={400} color={colors.white}>Range (e.g. 30-60)</Text></li>
            <li><Text fontSize='13px' fontWeight={400} color={colors.white}>Minimum (e.g. 30+)</Text></li>
            <li><Text fontSize='13px' fontWeight={400} color={colors.white}>&quot;ALAP&quot; for as long as possible</Text></li>
          </ul>
        </div>
      </ReactTooltip>

      <ReactTooltip
        id={peakPowerTooltipId}
        place='top'
        content='Athlete input only'
        positionStrategy='fixed'
        style={{
          zIndex: 9999,
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: colors.white,
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
        }}
      />

      <ReactTooltip
        id={velocityTooltipId}
        place='top'
        positionStrategy='fixed'
        content='Athlete input only'
        style={{
          zIndex: 9999,
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: colors.white,
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
        }}
      />

      <ReactTooltip
        id={restTooltipId}
        place='top'
        positionStrategy='fixed'
        content='Rest value will be the same for all sets.'
        style={{
          zIndex: 9999,
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: colors.white,
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
        }}
      />
    </Wrapper>
  );
};

ExerciseTable.defaultProps = {
  isRecurring: '',
};

ExerciseTable.propTypes = {
  content: PropTypes.instanceOf(Object).isRequired,
  swapDropdownSelectedExercise: PropTypes.instanceOf(Object).isRequired,
  index: PropTypes.number.isRequired,
  coachCompletion: PropTypes.bool.isRequired,
  completionOnly: PropTypes.bool.isRequired,
  isLeftAndRight: PropTypes.bool.isRequired,
  trackRepCount: PropTypes.bool.isRequired,
  trackVolumeLoad: PropTypes.bool.isRequired,
  forcePrUpdate: PropTypes.bool.isRequired,
  disablePrUpdate: PropTypes.bool.isRequired,
  nonSwappedItemFromParentCalendar: PropTypes.bool.isRequired,
  isRecurring: PropTypes.string,
  measure: PropTypes.func.isRequired,
  date: PropTypes.string,
  dayNumber: PropTypes.number,
};

ExerciseTable.defaultProps = {
  isRecurring: null,
  date: null,
  dayNumber: null,
};

export default ExerciseTable;
